import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';

import connect from 'app/libs/connect';
import wrapIn from 'app/enhancers/wrapIn';
import {
  titleKey,
  subtitleKey,
} from 'app/features/success/heroBlock/selectors';
import { clientReturnUrl } from 'app/features/checkout/selectors';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import BaseHeroBlock from 'app/components/HeroBlock/HeroBlock';

const UI = ({
  titleKey,
  subtitleKey,
  clientReturnUrl,
  buttonTextKey,
  imageUrl,
  image2XUrl,
}) => (
  <BaseHeroBlock
    titleKey={titleKey}
    subtitleKey={subtitleKey}
    buttons={{
      0: {
        type: 'one',
        textKey: buttonTextKey,
        testId: 'hero-block-take-me-home',
        to: clientReturnUrl,
      },
    }}
    image={{
      imageUrl,
      image2XUrl,
    }}
  />
);

UI.propTypes = {
  titleKey: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string.isRequired,
  clientReturnUrl: PropTypes.string.isRequired,
  buttonTextKey: PropTypes.string,
  imageUrl: PropTypes.string,
  image2XUrl: PropTypes.string,
};

UI.defaultProps = {
  buttonTextKey: 'buttons_take_me_home',
  imageUrl: 'img/hime/hime.png',
  image2XUrl: 'img/hime/hime@2x.png',
};

UI.displayName = 'HeroBlock';

const state = { titleKey, subtitleKey, clientReturnUrl };

const HeroBlock = compose(connect(state), wrapIn(BlockWrapper))(UI);

export { UI };

export default HeroBlock;
